import { Archive, Bookmark, List, LucideIcon } from 'lucide-react';

export const levels = ['beginner', 'intermediate', 'advanced', 'expert'];
export const stages = ['bookmarked', 'learned', 'all'];

type StageToIconsMap = Record<string, LucideIcon>;

export const productionUrl = 'https://gitexamples.com';

export const stageIcons: StageToIconsMap = {
  learned: Archive,
  bookmarked: Bookmark,
  all: List,
};

export const difficultyColors = [
  'bg-green-200',
  'bg-yellow-200',
  'bg-red-200',
  'bg-purple-200',
];

export type DashboardFilter =
  | 'all'
  | 'learned'
  | 'bookmarked'
  | 'beginner'
  | 'intermediate'
  | 'advanced'
  | 'expert';

type FilterToDescriptionMap = Record<DashboardFilter, string>;

export const filterDescriptions: FilterToDescriptionMap = {
  beginner: 'beginner examples to learn',
  intermediate: 'intermediate examples to learn',
  advanced: 'advanced examples to learn',
  expert: 'expert examples to learn',
  learned: 'learned examples',
  all: 'examples',
  bookmarked: 'bookmarked examples',
};
